import React, { Component } from 'react';
// import TopNav from './components/TopNav';

class App extends Component {

  render(){
    const { children, ...props } = this.props;
    return (
      <div className="container">
        { React.cloneElement(children, { ...props }) }
      </div>
    )
  }
}

export default App;
